import { render, staticRenderFns } from "@/templates/account/staffLogin.html?vue&type=template&id=0133ab20&"
import script from "./StaffLogin.vue?vue&type=script&lang=js&"
export * from "./StaffLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports